// extracted by mini-css-extract-plugin
export default {"button":"HeaderButton_button__9S4ga","Outline":"HeaderButton_Outline__pE4xl","Solid":"HeaderButton_Solid__Co-ex"};